/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { memo, useLayoutEffect, useRef, useState } from 'react'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import {
  trackEvent,
  useInteraction,
} from '@mercadoni/sinister/dist/cjs/monitors'
import { getProductListInfo } from '@mercadoni/sinister/dist/cjs/productv2'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { UseListContext } from '@mercadoni/sinister/dist/cjs/shoppingLists'

import useGuessAction from '@/hooks/useGuessAction'
import gotToPromoTag from '@/navigation/CSR/gotToPromoTag'
import useContainerWidth from '../../hooksv3/useContainerWidth'

import { usePathname, useRouter } from 'next/navigation'
import {
  hasOnClickBeaconAttribute,
  hasSponsored,
} from '../../utils/hasSponsored'
import { isSearchIntersectional } from '../../utils/productDisplay'

const ProductWithIntersectionalBannersLogic = ({
  Wrapper,
  products,
  category = {},
  trackSource,
  onProductClick,
  fetchMoreData,
  hasMoreData,
  searchValue,
}: any) => {
  const copies = getLocale() || defaultLocale
  const clientConfig = UseClientModelContext()
  const { visualViewport } = useContainerWidth(false)
  const [productsContainerWidth, setProductsContainerWidth] = useState(0)
  const { adsBanners, enhanceImg = false } = clientConfig
  const { favoriteService } = UseListContext()
  const { headerData, filtersPathInfo, pathNSearch } = useHeaderDataContext()
  const { sendInteractionEvent } = useInteraction()
  const router = useRouter()
  const onGuessAction = useGuessAction({ router, forceToLogin: false })
  const pathname = usePathname()
  const onClickPromoTag = gotToPromoTag(router)
  const productsContainerRef = useRef<HTMLElement>(null)

  const listInfo = {
    screen_name: headerData?.screenName,
    filters: filtersPathInfo,
    keyword: filtersPathInfo?.searchTerm,
    path: pathNSearch?.pathname,
    ...getProductListInfo(trackSource, category?.name, category?.reference),
  }

  const params = {
    modalProductAction: onProductClick,
    trackSource,
    listInfo,
  }
  const hasIntersectional = isSearchIntersectional({ params, adsBanners })

  const onClick = (product: any) => () => {
    if (hasSponsored({ clientConfig }) && hasOnClickBeaconAttribute(product)) {
      trackEvent({
        path: pathname,
        type: 'product',
        eventName: 'triggerOnClickBeacon',
        data: product?.promoted?.onClickBeacon,
      })
    }
    onProductClick(product)
  }

  useLayoutEffect(() => {
    const id = setTimeout(() => {
      setProductsContainerWidth(productsContainerRef?.current?.offsetWidth || 0)
    }, 500)

    return () => {
      clearTimeout(id)
    }
  }, [visualViewport])

  return (
    <Wrapper
      innerRef={productsContainerRef}
      products={products}
      hasMoreData={hasMoreData}
      fetchMoreData={fetchMoreData}
      trackSource={trackSource}
      enhanceImg={enhanceImg}
      onProductClick={onClick}
      listInfo={listInfo}
      adsBanners={adsBanners}
      hasIntersectional={hasIntersectional}
      copies={copies}
      favoriteService={favoriteService}
      sendInteractionEvent={sendInteractionEvent}
      onGuessAction={onGuessAction}
      onClickPromoTag={onClickPromoTag}
      searchValue={searchValue}
      productsContainerWidth={productsContainerWidth}
    />
  )
}

export default memo(ProductWithIntersectionalBannersLogic)
